





























































































import { Place, PhysicalAddress } from '@ssp/inscreva-sse-models';
import { Coordinate } from 'ol/coordinate';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Event } from '../models/event';
import { queryStore } from '../store/query';
import Loading from './base/Loading.vue';
import EventInfoPlaceAddress from './EventInfoPlaceAddress.vue';
import LocationPicker, { AddressData } from './LocationPicker.vue';

@Component({
  components: {
    EventInfoPlaceAddress,
    LocationPicker,
    Loading,
  },
})
export default class EventInfoPlaceComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  private isLoadingCepSearch: boolean = null;

  created() {
    this.event.info.place = (
      typeof this.event.info.place === 'string'
        ? { name: this.event.info.place, address: {} }
        : this.event.info.place || {}
    ) as Place;
  }

  $refs!: {
    nameValidation: InstanceType<typeof ValidationProvider>;
  };

  private async searchForCep(cep: string) {
    if (!cep || cep.length < 8) {
      return;
    }
    this.$refs.nameValidation.syncValue(cep);
    this.isLoadingCepSearch = true;
    await queryStore
      .findByPostalCode(cep)
      .then((data) => this.onCepFound(data as AddressData))
      .finally(() => (this.isLoadingCepSearch = false));
  }

  onChangeCoordinate(latLon: Coordinate) {
    (this.event.info.place as any).coordinates = { longitude: latLon[0], latitude: latLon[1] };
  }

  onCepFound({ addressInfo, geocodeInfo }: AddressData) {
    geocodeInfo = geocodeInfo || ({} as any);
    addressInfo = addressInfo || ({} as any);
    this.event.info.place = this.isPhysicalAddress(this.event.info.place) ? this.event.info.place : ({} as Place);
    this.event.info.place.name = geocodeInfo.streetName || addressInfo.street || '';
    (this.event.info.place as any).address = (this.event.info.place as any).address || {};
    (this.event.info.place as any).address.streetName = geocodeInfo.streetName || addressInfo?.street || '';
    (this.event.info.place as any).address.city = geocodeInfo.city || addressInfo.city || '';
    (this.event.info.place as any).address.state = geocodeInfo.state || addressInfo.state || '';
    this.onChangeCoordinate([geocodeInfo.longitude, geocodeInfo.latitude]);
  }

  isPhysicalAddress(place: string | Place): place is PhysicalAddress {
    return typeof place !== 'string' && !!Object.keys((place as PhysicalAddress).address || {}).length;
  }

  placeHasCoordinates(place: string | Place) {
    return this.isPhysicalAddress(place) && !!Object.keys(place.coordinates || {}).length;
  }
}
